export const MODULES = [
  'timesheet', 'finance', 'crm', 'equipment', 'booking', 'training',
  'disk', 'community', 'hr', 'documents', 'orders', 'news', 'reports',
] as const;

export type ModuleKey = typeof MODULES[number];
